export default __webpack_public_path__ + "static/media/edit-pencil.0b90d28d.svg";